import React from 'react';
import { Form } from 'react-bootstrap';
import type { ChangeDetailTabField } from '../../../types/changes';
import ChangeUserPickerInput from './ChangeUserPickerInput';
import SearchableSelect from './SearchableSelect';

interface Props {
  field: ChangeDetailTabField;
  value: string | number;
  onChange: (value: string | number) => void;
  disabled?: boolean;
}

const ChangeDetailTabFieldInput: React.FC<Props> = ({ field, value, onChange, disabled }) => {
  if (field.field_type === 'user_picker') {
    const userId = typeof value === 'number' ? value : Number(value) || 0;
    return (
      <ChangeUserPickerInput
        ariaLabel={field.label}
        value={userId}
        disabled={disabled}
        onChange={(id) => onChange(id)}
      />
    );
  }
  if (field.field_type === 'list') {
    return (
      <SearchableSelect
        ariaLabel={field.label}
        value={String(value || '')}
        disabled={disabled}
        searchEnabled
        options={(field.options || []).map((opt) => ({ value: opt, label: opt }))}
        onChange={(next) => onChange(next)}
      />
    );
  }
  if (field.field_type === 'text_long') {
    return (
      <Form.Control
        as="textarea"
        rows={3}
        aria-label={field.label}
        value={String(value || '')}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      />
    );
  }
  if (field.field_type === 'yes_no') {
    return (
      <Form.Select
        aria-label={field.label}
        value={String(value || '')}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Selecione</option>
        <option value="yes">Sim</option>
        <option value="no">Não</option>
      </Form.Select>
    );
  }
  return (
    <Form.Control
      type={field.field_type === 'integer' ? 'number' : 'text'}
      aria-label={field.label}
      value={String(value || '')}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};

export default ChangeDetailTabFieldInput;
